/**
 * Convert a title string to a URL-safe slug.
 * "Australia June 2026" → "australia-june-2026"
 * "Zach & Chloe's Italy Trip!!" → "zach-chloes-italy-trip"
 */
function slugify(title) {
  return title
    .toLowerCase()
    .replace(/[']/g, "")           // remove apostrophes (Chloe's → chloes)
    .replace(/[^a-z0-9]+/g, "-")   // non-alphanumeric → hyphen
    .replace(/^-+|-+$/g, "");      // trim leading/trailing hyphens
}

const MONTHS = ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"];
const HASH_CHARS = "abcdefghijklmnopqrstuvwxyz0123456789";

function generateShortHash() {
  let h = "";
  for (let i = 0; i < 4; i++) {
    h += HASH_CHARS[Math.floor(Math.random() * HASH_CHARS.length)];
  }
  return h;
}

/**
 * Generate a trip slug: {destination}-{mon}-{year}-{4char hash}
 * Example: "Australia", "2026-06-22" → "australia-jun-2026-k7x2"
 */
export function generateTripSlug(title, startDate) {
  const base = slugify(title);
  if (!base) throw new Error("Cannot generate slug from empty title");

  const [year, monthNum] = startDate.split("-");
  const mon = MONTHS[parseInt(monthNum, 10) - 1] || "trip";

  return `${base}-${mon}-${year}-${generateShortHash()}`;
}
